export default class MongoNotificationShowcaseInvitationAccept {
  showcaseId = "";
  showcaseTitle = "";

  inviteeId = "";
  inviteeName = "";
  inviteeLogoUrl = "";

  invitorId = "";
  invitorName = "";
  invitorLogoUrl = "";
}
